

// Initialize Flickity for '.custom-brodie-caraousel' if it exists
var elem1 = document.querySelector('.custom-brodie-caraousel');
if (elem1) {
    var flkty1 = new Flickity(elem1, {
        fade: true,
        prevNextButtons: true,
        imagesLoaded: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true
    });
}

// Initialize Flickity for '.custom-brodie-caraousel.v2-lil-gulp' if it exists
var elem2 = document.querySelector('.custom-brodie-caraousel.v2-lil-gulp');
if (elem2) {
    var flkty2 = new Flickity(elem2, {
        fade: true,
        prevNextButtons: true,
        imagesLoaded: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true
    });
}

if ($(".pf-trigger")[0]){

  var flkty = new Flickity('.pf-carousel', {
    fullscreen: true, 
    lazyLoad: 1, 
    prevNextButtons: false, 
    pageDots: false,
    autoPlay: true,
    pauseAutoPlayOnHover: false
  });
    
  flkty.on( 'change', function( index ) {
    $('.pf-wrapper').removeClass('open');
    if (index == 0) {        
      $('.pf1').addClass('open');
    } else if (index == 1) { $('.pf2').addClass('open');
    } else if (index == 2) { $('.pf3').addClass('open');
    } else if (index == 3) { $('.pf4').addClass('open');
    } else if (index == 4) { $('.pf5').addClass('open');
    } else if (index == 5) { $('.pf6').addClass('open');
    } else if (index == 6) { $('.pf7').addClass('open');
    } else if (index == 7) { $('.pf8').addClass('open');
    } else if (index == 8) { $('.pf9').addClass('open');
    } else if (index == 9) { $('.pf10').addClass('open');
    } else if (index == 10) { $('.pf11').addClass('open');
    } else if (index == 11) { $('.pf12').addClass('open');
    } else if (index == 12) { $('.pf13').addClass('open');
    } else if (index == 13) { $('.pf14').addClass('open') }
  });

  $('.pf-trigger').on('click', function() {
    flkty.pausePlayer();
    $('.pf-wrapper').removeClass('open');
    $(this).parent('.pf-wrapper').toggleClass('open');

    
    if ( $( this ).parent('.pf-wrapper').hasClass( "pf1" ) ) {
      flkty.select(0);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf2" ) ){
      flkty.select(1);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf3" ) ){
      flkty.select(2);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf4" ) ){
      flkty.select(3);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf5" ) ){
      flkty.select(4);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf6" ) ){
      flkty.select(5);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf7" ) ){
      flkty.select(6);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf8" ) ){
      flkty.select(7);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf9" ) ){
      flkty.select(8);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf10" ) ){
      flkty.select(9);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf11" ) ){
      flkty.select(10);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf12" ) ){
      flkty.select(11);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf13" ) ){
      flkty.select(12);
    } else if ( $( this ).parent('.pf-wrapper').hasClass( "pf14" ) ){
      flkty.select(13);
    }
    

  });


}


// Initialize AOS
AOS.init({
  once: true, // whether animation should happen only once - while scrolling down
});


$(document).ready(function() {
  // Initially add 'active' class to the first .color-wrapper
  // $('.color-wrapper').first().addClass('active');
  $(".color-wrapper").removeClass("active");
   $("input[type='radio']:checked").closest(".color-wrapper").addClass("active");

  
  // Update the color-title span with the text of the initially active color-wrapper
$('variant-radios').each(function() {
  var $radios = $(this);
  var colorText = $radios.find('.color-wrapper.active label').text();
  $radios.find('.color-title').text(colorText);
});

$('variant-radios').each(function() {
  // Handle click event on .color-wrapper elements within this specific variant-radios
  $(this).find('.color-wrapper').on('click', function() {
    const $radios = $(this).closest('variant-radios'); // Adjust to your element

    // Remove 'active' class only within this specific variant-radios
    $radios.find('.color-wrapper').removeClass('active');

    // Add 'active' class to the clicked .color-wrapper element
    $(this).addClass('active');

    // Update only this container's color-title span
    $radios.find('.color-title').text($(this).find('label').text());
  });
});

});

// 09-08-2024
$(document).ready(function() {
  var $wrapper = $('<div class="buy-quantity-wrapper"></div>');
   $('.product-form__input.product-form__quantity, .buy-buttons').wrapAll($wrapper);

// stylux app toggle
  $(".stylux-app-toggle").click(function(){
      $(this).addClass("active-toggle"); 
    $('.bg-transparent').trigger('click');
     setTimeout(function() {
         $('iframe').contents().find('body').click(function() {
                console.log('121212132dafkndafgnadg');
              $('.stylux-app-toggle').removeClass("active-toggle"); 
            });  
      },1000);
    }); 

    $('.quiz-btn').on('click', function(e) {
    e.preventDefault();
    $('#shopify-section-quiz-section').addClass('reveal');
     var quizSection = $("#shopify-section-quiz-section").offset();
      $('html, body').animate({
          scrollTop: quizSection.top - 50
      }, 100);
    });

  $('.menu-list').hover(
       function(){ $(this).addClass('hover-start').find('.grand-child-links').css('display','inline-grid').parents('.mega-menu__content').addClass('megamenu-wrap') },
       function(){ $(this).removeClass('hover-start').find('.grand-child-links').css('display','none').parents('.mega-menu__content').removeClass('megamenu-wrap') }
   )

// 02-09-24
  // --------------------faq section--------------
     $(".faq-question").click(function() {
     var find_closest=$(this).closest('.faq-item');
     var find_parent=find_closest.parents('.outer-accordion-item');
  var find_answer=find_parent.find('.faq-answer');
  
    if (find_answer.is(':visible')) {
     find_answer.slideUp(300);
    
      
    }
    if ($(this).next(".faq-answer").is(':visible')) {
      $(this).next(".faq-answer").slideUp(300);
      $(this).removeClass("openTab");
     
    } else {
      $(this).next(".faq-answer").slideDown(300);
       $(".faq-question").removeClass("openTab");
        $(this).addClass("openTab");
     
    }
  });
  $('.sidebar-list .lists>.list-links').on('click', function(e) {
    e.preventDefault();
     $(".sidebar-list .lists>.list-links").removeClass("active");
     $(this).addClass("active");
    var current_id = $(this).attr('id');
    console.log(current_id,'current_id');
     var accSection = $("#items-" +current_id).offset();
      $('html, body').animate({
          scrollTop: accSection.top - 280
      }, 100);
    $("#items-" +current_id).addClass('active');
    });

 });

// ----------desktop slider------
$('.video-slideshow .slideshow__controls .slider-button, .video-slideshow .slider-counter__link').click(function(){
   setTimeout(function() {
        $('.video-slideshow .slideshow__controls.slider-buttons button.slider-button.slider-button--prev').removeClass('disable-first-btn');
        $('.video-slideshow .slideshow__controls.slider-buttons .slider-button.slider-button--next').removeClass('disable-last-btn');
    if ($(".video-slideshow .slider.slider--everywhere .slider__slide[aria-hidden=false]").hasClass("last-slide-wrapper")) {
     $('.video-slideshow .slideshow__controls.slider-buttons .slider-button.slider-button--next').addClass('disable-last-btn');
 }},500)
    setTimeout(function() {
     if ($(".video-slideshow .slider.slider--everywhere .slider__slide.first-slide-wrapper[aria-hidden=false]").hasClass("first-slide-wrapper")) {
     $('.video-slideshow .slideshow__controls.slider-buttons button.slider-button.slider-button--prev').addClass('disable-first-btn');
 }
    },500);
});
// -------tabs---------
$('.summary-tabs').click(function(e) {
    e.preventDefault();

    let $this = $(this);
    let $content = $this.next('.accordion__content');

    // Check if the current tab is active
    if ($this.hasClass('active')) {
        // If active, remove the active class and slide up to close
        $this.removeClass('active');
        $content.removeClass('active').slideUp(300);
    } else {
        // If not active, just open it (no need to close others)
        $this.addClass('active');
        $content.addClass('active').slideDown(300);
    }
});


// ---------pdp slider------
// Initialize Flickity for '.main-content-outer' if it exists
var elem = document.querySelector('.main-content-outer');
if (elem) {
    var flkty = new Flickity(elem, {
        fade: true,
        prevNextButtons: true,
        imagesLoaded: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true
    });
}


// -------------faq menu-------------------
  $('.menu-faq').on('click',function(){
    var get_attr = $(this).attr('data-faq');
  console.log('get_attr',get_attr);      
    if(get_attr == 'general'){
      $(".sidebar-list .lists>.list-links#1").addClass("active");
      $(".sidebar-list .lists>.list-links#2").removeClass("active");
      $(".sidebar-list .lists>.list-links#3").removeClass("active");
      $(".sidebar-list .lists>.list-links#4").removeClass("active");
       var accSection = $("#items-1").offset();
      $('html, body').animate({
          scrollTop: accSection.top - 280
      }, 100);
    } 
    if(get_attr == 'maxine-one'){  
       $(".sidebar-list .lists>.list-links#2").addClass("active");
       $(".sidebar-list .lists>.list-links#1").removeClass("active");
       $(".sidebar-list .lists>.list-links#3").removeClass("active");
       $(".sidebar-list .lists>.list-links#4").removeClass("active");
        var accSection = $("#items-2").offset();
      $('html, body').animate({
          scrollTop: accSection.top - 280
      }, 100);
    } 
    if(get_attr == 'brodie-one'){
       $(".sidebar-list .lists>.list-links#3").addClass("active");
       $(".sidebar-list .lists>.list-links#1").removeClass("active");
       $(".sidebar-list .lists>.list-links#2").removeClass("active");
       $(".sidebar-list .lists>.list-links#4").removeClass("active");
        var accSection = $("#items-3").offset();
      $('html, body').animate({
          scrollTop: accSection.top - 280
      }, 100);
    }
    if(get_attr == 'lil-gulp'){
        $(".sidebar-list .lists>.list-links#4").addClass("active");
        $(".sidebar-list .lists>.list-links#1").removeClass("active");
        $(".sidebar-list .lists>.list-links#2").removeClass("active");
        $(".sidebar-list .lists>.list-links#3").removeClass("active");
       var accSection = $("#items-4").offset();
      $('html, body').animate({
          scrollTop: accSection.top - 280
      }, 100);
    }
     
 });


/* Ticker Animation and hide the ".cart__checkout-button" button if Loop Checkout+ loaded */
document.addEventListener('DOMContentLoaded', _ => {
  const items = [...document.getElementsByClassName('list__item')];
  const containerElem = document.getElementById('containerElem');
  const listElem = document.getElementById('list');
  
  // Ensure all necessary elements exist
  if (!containerElem || !listElem || items.length === 0) {
    console.warn('Ticker elements not found, animation will not run.');
    return;
  }

  const leftSideOfContainer = containerElem.getBoundingClientRect().left;
  let currentLeftValue = 0;
  
  // Kick off the animation function if elements are found
  window.setInterval(animationLoop, 20);
  
  function animationLoop() {
    const firstListItem = listElem.querySelector('.list__item:first-child');
    let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;
    
    if (rightSideOfFirstItem == leftSideOfContainer) {
      currentLeftValue = -1;
      listElem.appendChild(firstListItem);
    }

    listElem.style.marginLeft = `${currentLeftValue}px`;
    currentLeftValue--;
  }

  // Function to show/hide the "cart__checkout-button" button that duplicates offset "checkout+" button
  function toggleCheckoutButton(offsetExists) {
    const checkoutBtn = document.querySelector('.cart__checkout-button[name="SizeGuideTrigger"]');
    if (checkoutBtn) {
      checkoutBtn.style.display = offsetExists ? 'none' : 'flex';
    }
  }

  function checkOffset() {
    const offset = document.querySelector('.offset-cart-offer-container') !== null;
    toggleCheckoutButton(offset);
  }

  // Set up the observer to watch the cart drawer for changes
  const cartDrawer = document.querySelector('#CartDrawer') || document.querySelector('.cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(checkOffset);
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  checkOffset();

});
